import "./App.css";
import img1 from "./imgs/outro.webp";

function Chicago() {
  const styles = {
    outro: {
     display: "flex",
     alignItems: "center",
     justifyContent: "space-around",
    },
    leftOutro: {
     fontFamily: "Markazi Text",
    },
    leftOutroP: {
     fontFamily: "Karla",
    },
    rightOutroImg: {
     width: 480,
    },
   };
 return (
  <>
<article style={styles.outro}>
   <div style={styles.leftOutro}>
    <h1>Little Lemon</h1>
    <h5>Chicago</h5>
    <p style={styles.leftOutroP}>
     Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae laudantium,
     exercitationem consequatur blanditiis mollitia delectus incidunt minima
     eaque, cum necessitatibus autem quam magni, soluta ipsam nam voluptas amet.
     Ut, aspernatur?
    </p>
   </div>
   <div className="right__outro">
    <img
     src={img1}
     alt="master-chef smiling face"
     style={styles.rightOutroImg}
    />
   </div>
  </article>
  </>
 );
}

export default Chicago;
